import { postData } from './ApiSettings';

export const createPaymentLink = async (orderData) => {
    try {
        console.log('Creating payment session with data:', orderData);

        const response = await postData('/stripe/create-payment-link', {
            data: {
                orderId: orderData.orderId,
                documentId: orderData.documentId,
                amount: orderData.totalAmount,
                customerEmail: orderData.customerEmail,
                customerName: `${orderData.firstName} ${orderData.lastName}`,
                orderType: orderData.orderType || 'regular',
                // successUrl: orderData.orderType === 'workshop' 
                //     ? `${window.location.origin}/atelier-payment-complete?document_id=${orderData.documentId}`
                //     : orderData.orderType === 'formula'
                //     ? `${window.location.origin}/loisirs/payment-complete?document_id=${orderData.documentId}`
                //     : `${window.location.origin}/payment-complete?document_id=${orderData.documentId}`,
                // cancelUrl: orderData.orderType === 'workshop'
                //     ? `${window.location.origin}/ateliers`
                //     : orderData.orderType === 'formula'
                //     ? `${window.location.origin}/loisirs`
                //     : `${window.location.origin}/order-cancelled?order=${orderData.documentId}&cancelled=true`
            }
        });

        console.log('Server response:', response);

        if (response?.data?.data?.url) {
            return {
                url: response.data.data.url
            };
        }

        throw new Error('Invalid response format from server');
    } catch (error) {
        console.error('Detailed error in createPaymentLink:', {
            error,
            message: error.message,
            response: error.response?.data
        });
        throw error;
    }
};

export const verifyPaymentStatus = async (sessionId, documentId, paymentType = 'regular') => {
    try {
        // console.log('Verifying payment status for session:', sessionId, 'document:', documentId);

        const response = await postData('/stripe/verify-payment', {
            data: {
                sessionId,
                document_id: documentId,
                paymentType
            }
        }, {
            params: {
                document_id: documentId
            }
        });

        // console.log('Verification response:', response);

        if (!response?.data?.data) {
            throw new Error('Invalid response format');
        }

        return response.data.data;
    } catch (error) {
        console.error('Error verifying payment:', error);
        throw error;
    }
};

/**
 * Create a Stripe subscription checkout link
 * @param {Object} params - Subscription parameters
 * @returns {Promise<Object>} - The subscription checkout URL
 */
export const createSubscriptionLink = async ({
    orderId,
    documentId,
    monthlyAmount,
    customerEmail,
    firstName,
    lastName,
}) => {
    try {
        const dataToSend = {
            orderId,
            documentId,
            monthlyAmount,
            customerEmail,
            firstName,
            lastName,
            successUrl: `${window.location.origin}/loisirs/payment-complete?document_id=${documentId}&session_id={CHECKOUT_SESSION_ID}&type=sub`,
            cancelUrl: `${window.location.origin}/loisirs/checkout`,
        };

        console.log(dataToSend);

        const response = await postData(`/stripe/create-subscription`, dataToSend);
        // const response = await fetch(`${API_BASE_URL}/api/stripe/create-subscription`, {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //     },
        //     body: JSON.stringify({
        //         orderId,
        //         documentId,
        //         monthlyAmount,
        //         customerEmail,
        //         firstName,
        //         lastName,
        //         successUrl: `${window.location.origin}/loisirs/payment-complete?document_id=${documentId}&session_id={CHECKOUT_SESSION_ID}`,
        //         cancelUrl: `${window.location.origin}/loisirs/checkout`,
        //     }),
        // });


        console.log('Response create link: ', response)
        if (!response.data) {
            // const errorData = await response.json();
            throw new Error('Failed to create subscription link');
        }

        const data = await response.data;
        return data;
    } catch (error) {
        console.error('Error creating subscription link:', error);
        throw error;
    }
};



// NOUVELLES fonctions pour les ventes
export const createSalePaymentLink = async (paymentData) => {
    try {
      const response = await postData('/stripe/create-sale-payment', {
        data: {
          orderId: paymentData.orderId,
          documentId: paymentData.documentId,
          amount: paymentData.totalAmount,
          customerEmail: paymentData.customerEmail,
          customerName: `${paymentData.firstName} ${paymentData.lastName}`
        }
      });
  
      if (response.data?.data?.url) {
        return {
          success: true,
          url: response.data.data.url
        };
      } else {
        throw new Error('Invalid response from payment service');
      }
    } catch (error) {
      console.error('Error creating sale payment link:', error);
      throw new Error(error.response?.data?.error?.message || 'Failed to create payment link');
    }
  };
  
  export const verifySalePayment = async (sessionId, documentId) => {
    try {
      const response = await postData('/stripe/verify-sale-payment', {
        data: {
          sessionId,
          document_id: documentId
        }
      });
  
      return response.data.data;
    } catch (error) {
      console.error('Error verifying sale payment:', error);
      throw new Error(error.response?.data?.error?.message || 'Payment verification failed');
    }
  };